import React from 'react';
import { Grid, TextField } from '@mui/material';
import { useFormikContext } from 'formik';
import { AdminFieldLabel } from '@/admin/shared/AdminFieldLabel';
import { BROKER_GROUP_FIELD_LABELS } from './brokerGroupFormValues';

/**
 * A labelled text field in the broker group edit drawer's Grid, bound to Formik field
 * `name`. Shows its error, or else helperText. sm: its width from the sm breakpoint up. The
 * label has an undo icon once the field changes.
 */
export const BrokerGroupTextField = ({ name, helperText, sm = 12 }) => {
	const { getFieldProps, touched, errors } = useFormikContext();
	const error = touched[name] && errors[name];
	return (
		<Grid size={{ xs: 12, sm }}>
			<AdminFieldLabel name={name}>{BROKER_GROUP_FIELD_LABELS[name]}</AdminFieldLabel>
			<TextField
				fullWidth
				{...getFieldProps(name)}
				error={Boolean(error)}
				helperText={error || helperText}
			/>
		</Grid>
	);
};
